// ===== COMPUTER & INFORMATION SCIENCES =====
const IT_COMPS = [
  {
    id: "btech-it",
    name: "B.Tech in Information Technology",
    stream: "science",
    category: "it-comps",
    summary:
      "Focus on software, networking, databases, web/mobile apps, and IT infrastructure.",
    eligibility: "10+2 with PCM; entrance via JEE Main, state CETs, or CUET UG.",
    exams: ["JEE Main", "State CETs", "CUET UG"],
    colleges: [
      "NIT Trichy",
      "BIT Mesra",
      "IIIT Allahabad",
      "VIT Vellore",
      "PEC Chandigarh"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["software", "networking", "databases", "web development"],
  },
  {
    id: "bca",
    name: "BCA – Bachelor of Computer Applications",
    stream: "all",
    category: "it-comps",
    summary:
      "Applications-focused computing: programming, database management, web & mobile applications, and enterprise solutions.",
    eligibility: "Generally Open for all Streams, but 10+2 (Maths preferred by many); MCA after BCA.",
    exams: ["CUET UG", "State University Entrance Exams"],
    colleges: [
      "University of Delhi (DU)",
      "Christ University, Bangalore",
      "Loyola College, Chennai",
      "Amity University",
      "NIELIT (Levels A/B/C)"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["programming", "database", "software", "web apps"],
  },
  {
    id: "bsc-cs",
    name: "B.Sc in Computer Science",
    stream: "science",
    category: "it-comps",
    summary:
      "Core computing and theory: programming, databases, algorithms, AI, and systems.",
    eligibility: "10+2 with PCM/Maths; entrance via CUET UG or state-level CETs.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "University of Delhi (DU)",
      "Christ University, Bangalore",
      "St. Xavier's College, Mumbai",
      "Bangalore University",
      "Jamia Millia Islamia"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["programming", "software", "algorithms", "AI"],
  },
  {
    id: "btech-ai-ml",
    name: "B.Tech in Artificial Intelligence & Machine Learning",
    stream: "science",
    category: "it-comps",
    summary:
      "AI & ML: intelligent systems, deep learning, neural networks, computer vision, and data analytics.",
    eligibility: "10+2 with PCM; JEE Main/Advanced, CUET UG, or state CETs.",
    exams: ["JEE Main", "JEE Advanced", "CUET UG", "State CETs"],
    colleges: [
      "IIT Hyderabad",
      "IIT Bombay",
      "IIIT Hyderabad",
      "VIT Vellore",
      "Amity University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["AI", "ML", "deep learning", "data analytics"],
  },
  {
    id: "btech-cyber-security",
    name: "B.Tech in Cyber Security",
    stream: "science",
    category: "it-comps",
    summary:
      "Securing IT systems: cryptography, network security, ethical hacking, digital forensics, and security policy.",
    eligibility: "10+2 with PCM/Maths; entrance via JEE Main, CUET UG, or state CETs.",
    exams: ["JEE Main", "CUET UG", "State CETs"],
    colleges: [
      "IIT Delhi",
      "IIT Hyderabad",
      "IIIT Allahabad",
      "IIIT Guwahati",
      "Amity University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["cybersecurity", "hacking", "network security", "cryptography"],
  },
  {
    id: "btech-data-science",
    name: "B.Tech in Data Science",
    stream: "science",
    category: "it-comps",
    summary:
      "Data analysis, statistics, machine learning, data visualization, and business intelligence.",
    eligibility: "10+2 with PCM/Maths; entrance via JEE Main, CUET UG, or state CETs.",
    exams: ["JEE Main", "CUET UG", "State CETs"],
    colleges: [
      "IIT Kharagpur",
      "IIT Bombay",
      "IIIT Hyderabad",
      "VIT Vellore",
      "Amity University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["data", "analytics", "machine learning", "AI"],
  },
  {
    id: "btech-software-eng",
    name: "B.Tech in Software Engineering",
    stream: "science",
    category: "it-comps",
    summary:
      "Software development lifecycle, coding, testing, systems architecture, and DevOps practices.",
    eligibility: "10+2 with PCM; entrance via JEE Main, CUET UG, or state CETs.",
    exams: ["JEE Main", "CUET UG", "State CETs"],
    colleges: [
      "BITS Pilani",
      "VIT Vellore",
      "SRM Institute of Science & Technology",
      "Amity University",
      "Lovely Professional University"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["software", "development", "coding", "systems"],
  },
];

export default IT_COMPS;
